import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ContaCaixaConfiguracao } from '../../../models/conta-caixa-configuracao';
import { TipoLancamentoConfiguracao } from '../../../models/tipo-lancamento-configuracao';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-alterar-conta-em-massa-dialog',
  standalone: false,
  templateUrl: './alterar-conta-em-massa-dialog.component.html',
  styleUrl: './alterar-conta-em-massa-dialog.component.scss'
})
export class AlterarContaEmMassaDialogComponent {

  title: string = 'Alterar conta dos tipos selecionados';
  tipos: TipoLancamentoConfiguracao[] = [];
  contaAtual?: ContaCaixaConfiguracao;
  contas: ContaCaixaConfiguracao[] = [];

  contaSelecionada?: ContaCaixaConfiguracao;

  get contasDisponiveis(): ContaCaixaConfiguracao[] {
    return this.contas.filter(c => c.id !== this.contaAtual?.id);
  }

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<AlterarContaEmMassaDialogComponent>
  ) { }

  public salvarClick(): void {
    if (!this.contaSelecionada) {
      this.messageService.showToastWarning('Selecione uma conta destino');
      return;
    }

    this.configuracaoCaixaApiService.alterarContaTiposEmMassa({
      tiposIds: this.tipos.map(t => t.id),
      contaDestinoId: this.contaSelecionada.id
    }).subscribe(() => {
      this.messageService.showToastSuccess('Salvo com sucesso');
      this.dialogRef.close(true);
    });
  }
}
